import React from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { NavLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Link from "@mui/material/Link";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Utils from "../../../../../utils";

import MoreVertIcon from "@mui/icons-material/MoreVert";

const StyledTableContainer = styled(TableContainer)({
  width: "100%",
  minWidth: 720,
});

const StyledTable = styled(Table)({
  "& .tableCellHead": {
    border: "none",
    backgroundColor: "#f3f6f8",
  },
  "& .tableCellHead:first-of-type": {
    paddingLeft: 24,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    // boxShadow: "rgb(255 255 255) 8px 0px 0px inset",
  },
  "& .tableCellHead:last-of-type": {
    paddingRight: 24,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    // boxShadow: "rgb(255 255 255) -8px 0px 0px inset",
  },
  "& .tableCell": {
    borderColor: "#919eab3d",
    padding: "8px 16px",
  },
  "& .cellStatusAction": {
    width: 30,
  },
  "& .cellFullName": {
    width: 150,
  },
  "& .cellTypeLeave": {
    width: 100,
  },
  "& .cellStartStop": {
    width: 150,
  },
});

export default function TableList(props) {
  const { payRunList } = props;
  const { t, i18n } = useTranslation();

  return (
    <StyledTableContainer
      className="tableContainer"
      style={{ width: "100%", minHeight: 160 }}
    >
      <StyledTable aria-label="simple table" size="small">
        <TableHead>
          <TableRow>
            <TableCell className={`tableCellHead`} align="center">
              {t("ItemName")}
            </TableCell>
            <TableCell className={`tableCellHead`} align="center">
              {t("PaymentType")}
            </TableCell>
            <TableCell className={`tableCellHead`} align="center">
              {t("MonthRound")}
            </TableCell>
            <TableCell className={`tableCellHead`} align="center">
              {t("NumberOfEmployees")}
            </TableCell>
            <TableCell className={`tableCellHead`} align="center">
              {t("TotalPayroll")}
            </TableCell>
            <TableCell className={`tableCellHead`} align="center">
              {t("PayDate")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {payRunList.length > 0 ? (
            payRunList.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="center" className={`tableCell`}>
                  <Link
                    component={NavLink}
                    to={`/vendor/payroll/run/${row.idPayrun}`}
                    underline="hover"
                  >
                    {row.payrunName}
                  </Link>
                </TableCell>
                <TableCell align="center" className={`tableCell`}>
                  <Typography>
                    {row.paymentRound === "month"
                      ? `${t("Monthly")}-${t("HalfMonth")}`
                      : `${t("HalfMonth")}`}
                  </Typography>
                </TableCell>
                <TableCell align="center" className={`tableCell`}>
                  <Typography>
                    {dayjs(row.payrunPeriod)
                      .locale(localStorage.getItem("language") || "th")
                      .format(
                        localStorage.getItem("language") === "en"
                          ? "MMMM YYYY"
                          : "MMMM BBBB"
                      )}
                  </Typography>
                </TableCell>
                <TableCell align="center" className={`tableCell`}>
                  <Typography>{row.numberEmployee}</Typography>
                </TableCell>
                <TableCell align="center" className={`tableCell`}>
                  <Typography>
                    {Utils.numberWithCommas(row.netRound)}
                  </Typography>
                </TableCell>
                <TableCell align="center" className={`tableCell`}>
                  <Typography>
                    {row.paidDate
                      ? dayjs(row.paidDate)
                          .locale(localStorage.getItem("language") || "th")
                          .format(
                            localStorage.getItem("language") === "en"
                              ? "D MMMM YYYY"
                              : "D MMMM BBBB"
                          )
                      : ""}
                  </Typography>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <Typography color="text.secondary" style={{ margin: "8px 0" }}>
              {t("NoData")}
            </Typography>
          )}
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
}
